import React from 'react';
import { render } from 'react-dom'
import App from './containers/App/App';
import registerServiceWorker from './registerServiceWorker';
import { initializeFirebase, askForPermissioToReceiveNotifications } from './push-notification';
import './styles.css'

render(<App />, document.getElementById('root'));

registerServiceWorker();
initializeFirebase();
// askForPermissioToReceiveNotifications();


// WEBPACK FOOTER //
// ./src/index.js